<!-- 选择教室 -->
<template>
  <el-form-item :label="label">
    <yx-classroom-selector
      @select="select"
      ref="child"
      @clear="clear"
      :queryParams="params"
      :immediate="config.immediate"
      :placeholder="config.placeholder"
      :format="format"
      width="222px"
    />
  </el-form-item>
</template>

<script>
import { inject, onMounted, ref } from 'vue';

export default {
  kind: 'yq-教室选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ({}),
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default: '上课教室：',
    },
    format: Boolean,
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');
    function clear() {
      // eslint-disable-next-line no-use-before-define
      classroom.value = {};
      child.value.clearField();
    }

    function reset() {
      // eslint-disable-next-line no-use-before-define
      classroom.value = props.value;
      if (props.value.id) {
        child.value.setField(props.value.name);
      } else {
        child.value.clearField();
      }
    }
    const classroom = useQuery('classRoom', props.value, reset);

    function select(obj) {
      classroom.value = obj;
    }

    if (props.value.id) {
      onMounted(() => {
        child.value.setField(props.value.name);
      });
    }

    return {
      clear,
      select,
      child,
      reset
    };
  },
};
</script>
